































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { vxm } from '../../store.vuex';
import Datepicker from 'vuejs-datepicker';
import {en, de, es, fr} from 'vuejs-datepicker/dist/locale';
import VueToastr from '@deveodk/vue-toastr';
import '@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css';
import ProfilePlaceholder from '@/components/Commons/ProfilePlaceholder.vue';
import multipleLocationSelect from '../Commons/multiple-location-search.vue';
import AddEntity from '@/components/Commons/AddEntity.vue';
import ProfileInfo from '@/components/Commons/ProfileInfo.vue';
import Multiselect from 'vue-multiselect';
import LocationMultiSelect from '@/components/Commons/LocationMultiSelect.vue';
import { TIME_OPTIONS } from '@/components/Commons/timeOptions';
import { CustomFieldsMetaData } from '@/models/userdata/customfieldsmetadata';
import {
  MULTI_SELECT,
  DROPDOWN,
  SHORT_TEXT,
} from '@/models/jobs/CustomFieldType';
import { RADIO_BUTTON } from '../../models/jobs/CustomFieldType';
import { Metadata } from 'libphonenumber-js';

Vue.use(VueToastr, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 5000,
});

@Component({
  name: 'WorkPreference',
  components: {
    Datepicker,
    multipleLocationSelect,
    AddEntity,
    ProfileInfo,
    Multiselect,
    LocationMultiSelect,
    ProfilePlaceholder
  },
})
export default class WorkPreference extends Vue {
  $wlToastr: any;
  $moment: any;
  private MULTI_SELECT = MULTI_SELECT;
  private DROPDOWN = DROPDOWN;
  private RADIO_BUTTON = RADIO_BUTTON;
  private SHORT_TEXT = SHORT_TEXT;
  private errorString: string = '';
  private currentPayCurrency = '';
  private desiredPayCurrency = '';
  private viewMode: boolean = true;
  public phone: string = '';
  private numberErrors = {
    phone: '',
  };

  private desiredLocations: any = [];
  private shiftPreference: any = [];
  private willingToRelocate = false;
  private remotePreference: any = {};
  private availablityDate: any = null;
  private desiredMinSalary = '';
  private desiredMaxSalary = '';
  private currentPay = '';
  private currentPayUOM = '';
  private employmentPreference: any = [];
  private periodForSalary = '';
  private jobAvailability = '';
  private jobSearchStatus = '';
  private showShiftTimeRange = false;
  private shiftStartTime = this.timeOptions[0];
  private shiftEndTime = this.timeOptions[2];
  private customData: any = {};
  private oldCustomData: any = {};
  private errorMessage: any = {
    desiredWorkLocations: '',
    desiredPayandTimeFrame: '',
    currentPayandTimeFrame: '',
    availableToStartWork: '',
    employmentPreference: '',
    shiftPreference: '',
    remotePreference: '',
  };

  @Prop({ default: () => new Vue(), type: Vue }) bus;
  @Prop() isRequiredStep;
  @Prop() minimumEntries;
  @Prop() isLastStep;

  get getLanguage() {
    const lang = vxm.users.getUserLang || 'en';
    return {en, de, es, fr}[lang];
  }

  locationText(location) {
    const tempArray: any = [];
    location.city && tempArray.push(location.city);
    location.state && tempArray.push(location.state);
    if (!location.city && !location.state && location.country) {
      tempArray.push(location.country);
    }
    return tempArray.join(', ');
  }

  get hideCurrentPayField() {
    return vxm.configs.canHideThisFieldFromFieldConfig('HIDE_CURRENT_PAY_FIELD_IN_WORK_PREFERENCE', 'JOB_PREFERENCE','currentPay')
  }

  get hideJobSearchStatusField() {
    return vxm.configs.canHideThisFieldFromFieldConfig('HIDE_JOB_SEARCH_STATUS_IN_WORK_PREFERENCE', 'JOB_PREFERENCE','JOB_PREFERENCE_JOBSEARCHSTATUS')
  }

  get timeOptions() {
    return TIME_OPTIONS;
  }

  get fieldConfig() {
    return vxm.workpreference.FieldConfig;
  }

  get isFieldRequired() {
    return (fieldName) => {
      if (vxm.configs.IsConfigJSONEnabled) {
        return vxm.configs.requiredFieldConfigValue('JOB_PREFERENCE', fieldName);
      }
      let currentField = this.fieldConfig.find(
        (fieldData) => fieldData.field === fieldName,
      );
      return currentField && currentField.required;
    };
  }

  get isCustomFieldRequired() {
    return (metaData) => {
      return metaData.required;
    };
  }


  get fieldMinEntries() {
    return (fieldName) => {
      if (vxm.configs.IsConfigJSONEnabled) {
        return vxm.configs.minimumEntriesFieldConfigValue('JOB_PREFERENCE', fieldName);
      }
      let currentField = this.fieldConfig.find(
        (fieldData) => fieldData.field === fieldName,
      );
      return (currentField && currentField.minimumEntries) || 0;
    };
  }

  get dateAvailabilityEnabled() {
    return this.workPreferenceInfo.meta.jobAvailabilityType === '12';
  }

  get jobSearchStatusText() {
    const jobSearchStatus = this.workPreferenceInfo.jobSearchStatus;

    if (!jobSearchStatus) {
      return '--';
    }
    return jobSearchStatus;
  }
  
  get jobAvailabilityType(){
    if(isNaN(Number(this.workPreferenceInfo.jobAvailability))){
      return false;
    }
     return true;
  }

  get availabilityText() {
    if (!this.workPreferenceInfo.jobAvailability) {
      return '--';
    } else if (this.dateAvailabilityEnabled || this.jobAvailabilityType){
      if (isNaN(Number(this.workPreferenceInfo.jobAvailability))) {
        return '--';
      } else {
        return this.$moment(
          vxm.utility.convertUTCToLocalTime(
            Number(this.workPreferenceInfo.jobAvailability),
          ),
        ).format(this.getCompanyDateFormat.toUpperCase());
      }
    } else {
      return this.workPreferenceInfo.jobAvailability;
    }
  }

  get desiredSalaryText() {
    if (!Number(this.workPreferenceInfo.desiredMinSalary)) {
      return '--';
    }
    const desiredPayCurrency = this.getCurrency(this.workPreferenceInfo.desiredPayId);
    return `${desiredPayCurrency} ${this.workPreferenceInfo.desiredMinSalary}
     ${this.$t('workPreference-payuom-per-label')} ${this.workPreferenceInfo.periodForSalary}`;
  }

  get currentPayText() {
    if (!Number(this.workPreferenceInfo.currentPay)) {
      return '--';
    }
    const currentPay = this.workPreferenceInfo.currentPay && Number(this.workPreferenceInfo.currentPay).toFixed(2);
    const currentPayCurrency = this.getCurrency( this.workPreferenceInfo.currentPayId); 
    return `${currentPayCurrency} ${currentPay} ${this.$t('workPreference-payuom-per-label')} ${
      this.workPreferenceInfo.currentPayUOM
    }`;
  }

  shiftEndTimeText(time, index) {
    const difference = this.shiftTimeDifference(index);
    return `${time} (${difference} ${difference === 1 ? 'hr' : 'hrs'})`;
  }

  get alignmentClass() {
    return this.isProfilePage ? 'col-lg-6 col-xl-5 mb-3' : 'col-12 mb-3';
  }
  get alignmentClassLong() {
    return this.isProfilePage ? 'col-lg-12 col-xl-10 mb-3' : 'col-12 mb-3';
  }

  get formContainerClass() {
    return this.isProfilePage ? 'col' : 'col-lg-8';
  }

  get getCompanyDateFormat() {
    return vxm.jobs.getCompanyDateFormat;
  }

  get employmentPreferenceOptions() {
    return vxm.workpreference.WorkPreferenceInfo.meta
      .employmentPreferenceOptions;
  }

  get shiftPreferenceOptions() {
    return vxm.workpreference.WorkPreferenceInfo.meta.shiftPreferenceOptions;
  }

  get jobAvailabilityOptions() {
    return vxm.workpreference.WorkPreferenceInfo.meta.jobAvailabilityOptions;
  }

  get periodOfSalaryOptions() {
    return vxm.workpreference.WorkPreferenceInfo.meta.periodOfSalaryOptions;
  }

  get currencyOptions(){
     return vxm.workpreference.WorkPreferenceInfo.meta.currencyOptions;
  }
  
  get getcurrencyMasterId(){
      const currency = vxm.workpreference.WorkPreferenceInfo.meta.currencyOptions.find(option => option.symbol === this.workPreferenceInfo.currency);
      return currency ? currency.currencyMasterId : 1 ;
    }

  getCurrency(currencyMasterId){
    const currency = vxm.workpreference.WorkPreferenceInfo.meta.currencyOptions.find(option => option.currencyMasterId === currencyMasterId);
    return currency ? currency.symbol : this.workPreferenceInfo.currency;
  }

  get hasCustomData() {
    return (
      vxm.workpreference.WorkPreferenceInfo.meta &&
      vxm.workpreference.WorkPreferenceInfo.meta.candidateCustomMetaData &&
      vxm.workpreference.WorkPreferenceInfo.meta.candidateCustomMetaData.length
    );
  }

  get candidateCustomMetaData() {
    return (
      (vxm.workpreference.WorkPreferenceInfo.meta &&
        vxm.workpreference.WorkPreferenceInfo.meta.candidateCustomMetaData) ||
      []
    );
  }

  get isLoggedIn() {
    return vxm.users.isLoggedIn;
  }

  get isProfilePage() {
    if (this.$router.currentRoute.name === 'GuidedSignup') {
      this.viewMode = false;
      if (!this.userPermissionConfig('edit')) {
        this.viewMode = true;
      }
        if(this.userPermissionConfig('edit') && !this.isWorkPreferenceCoreFieldVisible() && !this.hasCustomData){
        this.viewMode = true;
      }
      return this.viewMode
    }
    else{
      return this.$router.currentRoute.name === 'WorkPreference';
    }
  }

  showEditProfilePage() {
    this.oldCustomData = JSON.parse(JSON.stringify(this.customData));
    this.viewMode = false;
  }
  userPermissionConfig(permission) {
    return vxm.configs.getUserPermissionConfig(permission, 'JOB_PREFERENCE');
  }

  isProfessionalFieldVisible(key: string) {
    if (vxm.configs.IsConfigJSONEnabled) {
      return vxm.configs.visibilityFieldConfigValue('JOB_PREFERENCE', key);
    }
    return true;
  }


  get isShiftPreferenceEnabled(){
    return !vxm.configs.getGlobalConfigValue('HIDE_SHIFT_PREFERENCE_FIELD_IN_WORK_PREFERENCE');
  }

  get sectionName() {
    if (this.$route.name && this.$route.name === 'GuidedSignup') {
      const section = vxm.configs.ClientConfigs.profileWizardConfig.profileSections.find(
        (section) => section.sectionKey === 'JOB_PREFERENCE',
      );
      return section ? section.displayName : 'Work Preferences';
    }
    const section = vxm.configs.ClientConfigs.userProfileConfig.profileSections.find(
      (section) => section.sectionKey === 'JOB_PREFERENCE',
    );
    return section ? section.displayName : 'Work Preferences';
  }

  isWorkPreferenceCoreFieldVisible() {
    if (vxm.configs.IsConfigJSONEnabled) {
      let section = vxm.configs.ClientConfigs.userProfileSections.find(
        (option) => option.sectionKey === 'JOB_PREFERENCE',
      );
      if (section && section.fieldConfig) {
        let visibilitySections = section.fieldConfig.filter((field) => {
          return field.visibility});
          console.log("visibilitySections.length",visibilitySections);
         return visibilitySections.length > 0 ? true : false
      }
      return true;
    }
    return true;
  }

  onApplyShiftTime() {
    if (this.shiftStartTime === this.shiftEndTime) {
      return;
    }
    const endTimeIndex = this.timeOptions.findIndex(
      (option) => option === this.shiftEndTime,
    );
    const diff = this.shiftTimeDifference(endTimeIndex);
    const value = `${this.shiftStartTime} - ${this.shiftEndTime} (${diff} ${
      diff === 1 ? 'hr' : 'hrs'
    })`;
    const isOptionAlreadySelected = this.shiftPreference.find(
      (preference) => preference.value === value,
    );
    !isOptionAlreadySelected &&
      this.shiftPreference.push({ text: value, value });
    this.showShiftTimeRange = false;
  }

  onSelectShiftPreference(option) {
    this.showShiftTimeRange = option.value === 'Select time'||option.value==='Time Range';
    this.shiftStartTime = this.timeOptions[0];
    this.shiftEndTime = this.timeOptions[2];
    setTimeout(() => {
      this.shiftPreference = this.shiftPreference.filter(
        (option) => option.text !== 'Select time' || option.text !=='Time Range',
      );
    });
  }

  onOpenShiftPreference() {
    this.showShiftTimeRange = false;
  }

  shiftTimeDifference(endTimeIndex) {
    const startTimeIndex = this.timeOptions.findIndex(
      (option) => option === this.shiftStartTime,
    );
    let diff = endTimeIndex - startTimeIndex;
    if (diff < 0) {
      diff = 48 + diff;
    }
    return diff / 2;
  }

  get remotePreferenceOptions() {
    return vxm.workpreference.WorkPreferenceInfo.meta.remotePreference;
  }

  get jobSerachStatusOptions() {
    return vxm.workpreference.WorkPreferenceInfo.meta.jobSearchStatusOptions;
  }

  async mounted() {
    this.viewMode = this.isProfilePage;
    console.log("thisminimumEntries ", this.minimumEntries);
    console.log("this.isRequiredStep ", this.isRequiredStep);

    this.bus.$on('on-next-step', this.updateChanges);
    try {
      await vxm.workpreference.fetchWorkPreference();
    } catch (e) {
      this.$wlToastr(
        'error',
        this.$t('error.fetching.workpreference'),
        this.$t('profile-accordion.work_preference'),
      );
    }
    this.desiredLocations = [...this.workPreferenceInfo.desiredLocations];
    this.currentPayCurrency = this.workPreferenceInfo.currentPayId ? this.workPreferenceInfo.currentPayId : this.getcurrencyMasterId ;
    this.desiredPayCurrency = this.workPreferenceInfo.desiredPayId ? this.workPreferenceInfo.desiredPayId : this.getcurrencyMasterId ;
    this.currentPay = this.workPreferenceInfo.currentPay || '';
    this.currentPayUOM = this.workPreferenceInfo.currentPayUOM || '';
    this.desiredMinSalary =
      (this.workPreferenceInfo.desiredMinSalary === '0.00')||( this.workPreferenceInfo.desiredMinSalary === '0')
        ? ''
        : this.workPreferenceInfo.desiredMinSalary;
    this.desiredMaxSalary =
      this.workPreferenceInfo.desiredMaxSalary === '0.00'
        ? ''
        : this.workPreferenceInfo.desiredMaxSalary;
    this.periodForSalary = this.workPreferenceInfo.periodForSalary || '';
    this.setJobAvailablity();
    this.employmentPreference = this.workPreferenceInfo.employmentPreference
      ? this.workPreferenceInfo.employmentPreference
          .split(',')
          .map((option) => ({ text: option, value: option }))
      : [];
    this.willingToRelocate = this.workPreferenceInfo.willingToRelocate;
    this.remotePreference =
      (this.workPreferenceInfo.remotePreference &&
        this.workPreferenceInfo.remotePreference[0]) ||
      null;
    this.shiftPreference = this.workPreferenceInfo.shiftPreferences
      .filter((option) => option)
      .map((option) => ({
        text: option,
        value: option,
      }));

    this.jobSearchStatus = this.workPreferenceInfo.jobSearchStatus || '';
    if (this.hasCustomData && this.workPreferenceInfo.customData) {
      const customData = {};
      this.candidateCustomMetaData.forEach((metaData) => {
        if (!metaData.visibility) {
          customData[metaData.name] = this.workPreferenceInfo.customData[
            metaData.name
          ];
          return;
        }
        if (metaData.type === MULTI_SELECT) {
          const value = this.workPreferenceInfo.customData[metaData.name];
          if (value) {
            customData[metaData.name] = value.split(',').map((option) => {
              return {
                text: option,
                value: option,
              };
            });
          }
        } else if (metaData.type === DROPDOWN) {
          const value = this.workPreferenceInfo.customData[metaData.name];
          if (value) {
            customData[metaData.name] = {
              text: value,
              value: value,
            };
          }
        } else if (metaData.type === RADIO_BUTTON) {
          const value =
            this.workPreferenceInfo.customData[metaData.name] === 'Yes';
          if (value !== undefined) {
            customData[metaData.name] = value;
          }
        } else if (metaData.type === SHORT_TEXT) {
          const value = this.workPreferenceInfo.customData[metaData.name];
          if (value) {
            customData[metaData.name] = value;
          }
        }
      });
      this.customData = customData;
    }
    let jobAvailability;
    if (this.dateAvailabilityEnabled) {
      if (this.availablityDate) {
        jobAvailability = vxm.utility.convertLocalTimeToUTC(
          new Date(this.availablityDate),
        );
      } else {
        jobAvailability = '';
      }
    } else {
      jobAvailability = this.jobAvailability;
    }
    if (this.checkIfAllMandatoryAnswered(jobAvailability)) {
      this.$emit('disable-next-button', false);

    }
    else{
      this.$emit('disable-next-button', true);

    }
  }

  getFieldValue(metaData) {
    if (metaData.type === RADIO_BUTTON) {
      return this.customData[metaData.name] ? 'Yes' : 'No';
    }
    return this.customData[metaData.name];
  }

  getShortTextFielValue(metaData) {
    return metaData.defaultValue;
  }

  setJobAvailablity() {
    if (this.dateAvailabilityEnabled) {
      if (this.workPreferenceInfo.jobAvailability) {
        this.availablityDate = vxm.utility.convertUTCToLocalTime(
          Number(this.workPreferenceInfo.jobAvailability),
        );
      }
    } else {
      this.jobAvailability = this.workPreferenceInfo.jobAvailability;
    }
  }

  get workPreferenceInfo() {
    return vxm.workpreference.WorkPreferenceInfo;
  }

  beforeDestroy() {
    this.bus.$off('on-next-step');
  }

  cancelChanges() {
    this.desiredLocations = [...this.workPreferenceInfo.desiredLocations];
    this.currentPayCurrency = this.workPreferenceInfo.currentPayId || '';
    this.desiredPayCurrency = this.workPreferenceInfo.desiredPayId || '';
    this.currentPay = this.workPreferenceInfo.currentPay || '';
    this.currentPayUOM = this.workPreferenceInfo.currentPayUOM || '';
    this.desiredMinSalary =
      this.workPreferenceInfo.desiredMinSalary === '0.00'
        ? ''
        : this.workPreferenceInfo.desiredMinSalary;
    this.desiredMaxSalary =
      this.workPreferenceInfo.desiredMaxSalary === '0.00'
        ? ''
        : this.workPreferenceInfo.desiredMaxSalary;
    this.periodForSalary = this.workPreferenceInfo.periodForSalary || '';
    this.setJobAvailablity();
    this.employmentPreference = this.workPreferenceInfo.employmentPreference
      ? this.workPreferenceInfo.employmentPreference
          .split(',')
          .map((option) => ({ text: option, value: option }))
      : [];
    this.willingToRelocate = this.workPreferenceInfo.willingToRelocate;
    this.remotePreference =
      (this.workPreferenceInfo.remotePreference &&
        this.workPreferenceInfo.remotePreference[0]) ||
      null;
    this.shiftPreference = this.workPreferenceInfo.shiftPreferences
      .filter((option) => option)
      .map((option) => ({
        text: option,
        value: option,
      }));

    this.jobSearchStatus = this.workPreferenceInfo.jobSearchStatus || '';
    this.jobAvailability = this.workPreferenceInfo.jobAvailability;
    this.viewMode = true;
  }
  
  checkIfAllMandatoryAnswered(jobAvailability) {
    if (
      this.isFieldRequired('JOB_PREFERENCE_DESIREDLOCATIONS') &&
      this.desiredLocations.length < this.fieldMinEntries('JOB_PREFERENCE_DESIREDLOCATIONS')
    ) {
      return false
    }
    if (this.isFieldRequired('JOB_PREFERENCE_DESIREDMINSALARY')) {
      if (!this.desiredMinSalary && !this.periodForSalary) {
        return false
      } else if (!this.periodForSalary) {
        return false
      }
    } else {
 if (Number(this.desiredMinSalary) && !this.periodForSalary) {
        return false
      }
    }
    if (this.isFieldRequired('JOB_PREFERENCE_JOBAVAILABILITY') && !jobAvailability) {

      return false
    }

    if (
      this.isFieldRequired('JOB_PREFERENCE_EMPLOYMENT_PREFERENCE') &&
      this.employmentPreference.length <
        this.fieldMinEntries('JOB_PREFERENCE_EMPLOYMENT_PREFERENCE')
    ) {

      return false
    }

    if (
      this.isFieldRequired('JOB_PREFERENCE_SHIFT_PREFERENCE') &&
      this.shiftPreference.length < this.fieldMinEntries('JOB_PREFERENCE_SHIFT_PREFERENCE')
    ) {

      return false
    }

    if (this.isFieldRequired('JOB_PREFERENCE_REMOTEWORK_PREFERENCE') && this.remotePreference) {

      return false
    }

    if (!Number(this.currentPay) && this.currentPayUOM) {
      return false
    } else if (Number(this.currentPay) && !this.currentPayUOM) {
      return false
    }

    this.candidateCustomMetaData.forEach((metaData) => {
      const metaDataName = metaData.name;
      if (
        metaData.required &&
        (this.customData[metaData.name] === undefined ||
          this.getFieldValue(metaData) === '' ||
          (Array.isArray(this.getFieldValue(metaData)) && !this.getFieldValue(metaData).length )
        )
      ) {
       
        return false;
      }
    });

  
    return true;
    
  }
  validateAnswered() {
    let jobAvailability;
    if (this.dateAvailabilityEnabled) {
      if (this.availablityDate) {
        jobAvailability = vxm.utility.convertLocalTimeToUTC(
          new Date(this.availablityDate),
        );
      } else {
        jobAvailability = '';
      }
    } else {
      jobAvailability = this.jobAvailability;
    }
    if (this.checkIfAllMandatoryAnswered(jobAvailability)) {
      this.$emit('disable-next-button', false);

    }
    else {
      this.$emit('disable-next-button', true);
    }
  }
  validateData(jobAvailability) {
    if (
      this.isFieldRequired('JOB_PREFERENCE_DESIREDLOCATIONS') &&
      this.desiredLocations.length < this.fieldMinEntries('JOB_PREFERENCE_DESIREDLOCATIONS')
    ) {
      this.errorMessage.desiredWorkLocations = this.$t('provide.atleast.one.desiredlocation', { desiredlocationcount: this.fieldMinEntries('JOB_PREFERENCE_DESIREDLOCATIONS') }).toString();     
    } else {
      this.errorMessage.desiredWorkLocations = '';
    }
    if (this.isFieldRequired('JOB_PREFERENCE_DESIREDMINSALARY')) {
      if (!this.desiredMinSalary) {
        this.errorMessage.desiredPayandTimeFrame = this.$t('enter.desired.pay').toString();
      } else if (!this.periodForSalary) {
        this.errorMessage.desiredPayandTimeFrame = this.$t('enter.period.for.pay').toString();
      } else if(!this.desiredPayCurrency){
        this.errorMessage.desiredPayandTimeFrame = this.$t('enter.currency.for.desired.pay').toString();
      }
      else {
        this.errorMessage.desiredPayandTimeFrame = '';
      }
    } else {
      if (!Number(this.desiredMinSalary) && this.periodForSalary) {
        this.errorMessage.desiredPayandTimeFrame = this.$t('enter.desired.pay').toString();
      } else if (Number(this.desiredMinSalary) && !this.periodForSalary) {
        this.errorMessage.desiredPayandTimeFrame = this.$t('enter.period.for.pay').toString();
      }else if(!this.desiredPayCurrency){
        this.errorMessage.desiredPayandTimeFrame = this.$t('enter.currency.for.desired.pay').toString();
      }
       else {
        this.errorMessage.desiredPayandTimeFrame = '';
      }
    }
    if (this.isFieldRequired('JOB_PREFERENCE_JOBAVAILABILITY') && !jobAvailability) {
      this.errorMessage.availableToStartWork = this.$t('this.field.required');
    } else {
      this.errorMessage.availableToStartWork = '';
    }

    if (
      this.isFieldRequired('JOB_PREFERENCE_EMPLOYMENT_PREFERENCE') &&
      this.employmentPreference.length <
        this.fieldMinEntries('JOB_PREFERENCE_EMPLOYMENT_PREFERENCE')
    ) {
      this.errorMessage.employmentPreference = this.$t('provide.atleast.one.empPreference',{empPreferenceCount:this.fieldMinEntries('JOB_PREFERENCE_EMPLOYMENT_PREFERENCE')}).toString();
    } else {
      this.errorMessage.employmentPreference = '';
    }

    if (
      this.isFieldRequired('JOB_PREFERENCE_SHIFT_PREFERENCE') &&
      this.shiftPreference.length < this.fieldMinEntries('JOB_PREFERENCE_SHIFT_PREFERENCE')
    ) {
      this.errorMessage.shiftPreference = this.$t('provide.atleast.one.shiftpreference', {shiftpreferencecount:this.fieldMinEntries('JOB_PREFERENCE_SHIFT_PREFERENCE')}).toString();
        // 'Please provide atleast ' +
        // this.fieldMinEntries('JOB_PREFERENCE_SHIFT_PREFERENCE') +
        // ' shift preference';
    } else {
      this.errorMessage.shiftPreference = '';
    }

    if (this.isFieldRequired('JOB_PREFERENCE_REMOTEWORK_PREFERENCE') && this.remotePreference) {
      this.errorMessage.remotePreference = this.$t('this.field.required');
    } else {
      this.errorMessage.remotePreference = '';
    }

    if (!Number(this.currentPay) && this.currentPayUOM) {
      this.errorMessage.currentPayandTimeFrame = this.$t('enter.currency.for.desired.pay').toString();
    } else if (Number(this.currentPay) && !this.currentPayUOM) {
      this.errorMessage.currentPayandTimeFrame = this.$t('period.for.current.pay').toString();
    } else if(!this.currentPayCurrency){
      this.errorMessage.currentPayandTimeFrame = this.$t('enter.currency.for.current.pay').toString();
    }else {
      this.errorMessage.currentPayandTimeFrame = '';
    }

    this.candidateCustomMetaData.forEach((metaData) => {
      const metaDataName = metaData.name;
      if (metaData.type === RADIO_BUTTON) {
        this.errorMessage[metaDataName] = '';
        return;
      } else if (
        metaData.required &&
        (this.customData[metaData.name] === undefined ||
          this.getFieldValue(metaData) === '' ||
          (Array.isArray(this.getFieldValue(metaData)) && !this.getFieldValue(metaData).length )
        )
      ) {
        this.errorMessage[metaDataName] = this.$t('this.field.required');
        this.errorMessage = { ...this.errorMessage };
        valid = false;
      } else {
        this.errorMessage[metaDataName] = '';
      }
    });

    let valid = true;
    Object.keys(this.errorMessage).forEach((entity) => {
      valid = valid && !this.errorMessage[entity];
    });
    return valid;
  }

  async updateChanges() {
    let jobAvailability;
    if (this.dateAvailabilityEnabled) {
      if (this.availablityDate) {
        jobAvailability = vxm.utility.convertLocalTimeToUTC(
          new Date(this.availablityDate),
        );
      } else {
        jobAvailability = '';
      }
    } else {
      jobAvailability = this.jobAvailability;
    }
    const isDataValid = this.validateData(jobAvailability);
    if (!isDataValid) {
      return;

    }
    this.$emit('disable-next-button', false);

    this.currentPay =
      (this.currentPay && Number(this.currentPay).toFixed(2)) || '';
    const payload: any = {
      desiredPayId : this.desiredPayCurrency,
      desiredMinSalary: this.desiredMinSalary,
      desiredMaxSalary: this.desiredMaxSalary,
      desiredLocations: this.desiredLocations,
      currentPayId : this.currentPayCurrency,
      currentPay: this.currentPay,
      currentPayUOM: this.currentPayUOM,
      jobAvailability: jobAvailability.toString(),
      shiftPreferences: this.shiftPreference.map((option) => option.value),
      remotePreference: this.remotePreference ? [this.remotePreference] : [],
      willingToRelocate: this.willingToRelocate,
      periodForSalary: this.periodForSalary,
      jobSearchStatus: this.jobSearchStatus,
      employmentPreference: this.employmentPreference
        .map((peference) => peference.text)
        .join(','),
    };
    if (this.hasCustomData) {
      payload.customData = {};
      this.candidateCustomMetaData.map((metaData) => {
        if (!metaData.visibility) {
          payload.customData[metaData.name] = this.customData[metaData.name];
          return;
        }
        if (Array.isArray(this.customData[metaData.name])) {
          payload.customData[metaData.name] = this.customData[metaData.name]
            .map((option) => option.text)
            .join(',');
        } else if (metaData.type === RADIO_BUTTON) {
          payload.customData[metaData.name] = this.customData[metaData.name]
            ? 'Yes'
            : 'No';
        } else if (metaData.type === SHORT_TEXT) {
          payload.customData[metaData.name] = this.customData[metaData.name];
        } else if (this.customData[metaData.name]) {
          payload.customData[metaData.name] = this.customData[
            metaData.name
          ].text;
        } else {
          payload.customData[metaData.name] = '';
        }
      });
    }
    try {
      const response = await vxm.workpreference.saveWorkPreference(payload);
      vxm.users.getProfileStrength();
      await vxm.workpreference.fetchWorkPreference();
      if (response.meta.success) {
        vxm.users.Rudderstack.trackEvent("Work Preference Updated", {WorkPreferenceDetails : payload})
        await vxm.users.validateMandatorySteps();
        if (vxm.users.MissedMandatorySteps.length && this.isLastStep) {
           this.$emit('missed-mandatory', vxm.users.MissedMandatorySteps);
        } else {
          this.$wlToastr('success', this.$t('saved.successfully'), this.$t('profile-accordion.work_preference'));
          this.$emit('go-to-next');
       }
        this.viewMode = true;
      } else if (response.meta.error && response.meta.error.detailedMessage) {
        this.$wlToastr(
          'error',
          response.meta.error.detailedMessage,
          this.$t('profile-accordion.work_preference'),
        );
      } else {
        this.$wlToastr(
          'error',
          `${this.$t('something.went.wrong')}. ${this.$t('please.try.again')}`,
          this.$t('profile-accordion.work_preference'),
        );
      }
    } catch (e) {
      let message = `${this.$t('something.went.wrong')}. ${this.$t('please.try.again')}`;
      if (
        e.response.data &&
        e.response.data.meta &&
        e.response.data.meta.error &&
        e.response.data.meta.error.detailedMessage
      ) {
        message = e.response.data.meta.error.detailedMessage;
      }
      this.$wlToastr('error', message, this.$t('profile-accordion.work_preference'));
    }
  }
  isNumber(evt) {
    evt = evt ? evt : window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      evt.preventDefault();
    }
    return true;
  }
}
